import { Component, ViewChild, ElementRef } from '@angular/core'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { Category } from '../../../models/Category'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { NotificationService } from '../../../services/notification.service'
import { ActivatedRoute, Router } from '@angular/router'
import { BotanicService } from '../../../services/botanic.service'
import { AWSService } from '../../../services/aws.service'
import { NgForm } from '@angular/forms'
import { SubCategory } from '../../../models/SubCategory'
import { Alternative } from '../../../models/Alternative'
import { BotanicClassification } from '../../../models/BotanicClassification'

@Component({
	selector: 'app-botanic',
	templateUrl: './botanic.component.html'
})
export class BotanicComponent {
	@ViewChild('form') public form: NgForm
	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective
	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}
	public class: Array<BotanicClassification>
	public classSelected: BotanicClassification
	public category: Category
	public categorySelected: Category
	public categories: Array<Category> = []
	public subCategory: SubCategory
	public subCategorySelected: SubCategory
	public subCategories: Array<SubCategory> = []
	public alternative: Alternative
	public alternativeSelected: Alternative
	public modalClassBotanic: boolean = false
	public modalNewCateg: boolean = false
	public modalEditCateg: boolean = false
	public modalNewSubCateg: boolean = false
	public modalEditSubCateg: boolean = false
	public modalEditClass: boolean = false
	public modalDataTable: boolean = false
	public modalEditDataTable: boolean = false
	public openDelete: boolean = false
	public ViewValidation: ViewValidation = new ViewValidation()
	public imageUserSelected: any
	public imageAlternative: any
	public nameFileAlternative: string
	public imageUser: any
	public existImage: boolean
	public existImageEdited: boolean = false
	public fileInput: any
	public tab1: boolean = false
	public tab2: boolean = false
	public tab3: boolean = false
	public subscriptionAdd
	public subscriptionGet
	public subscriptionRemove
	public loading: boolean = false
	public isLoading: boolean = false

	constructor(
		private botanicService: BotanicService,
		private notificationService: NotificationService,
		private activateRoute: ActivatedRoute,
		private router: Router,
		private awsService: AWSService
	) {}

	public ngOnInit() {
		this.notificationService.starterLoading.subscribe(
			() => (this.loading = true)
		)
		this.notificationService.stopperLoading.subscribe(
			() => (this.loading = false)
		)
		this.getBotanicResolver()
		this.setupDatatables()
		this.initTab()
		this.getCategories()
		this.category = new Category()
		this.categorySelected = new Category()
		this.alternative = new Alternative()
		this.alternativeSelected = new Alternative()
		this.imageUserSelected = undefined
	}

	public ngAfterViewInit() {
		this.refreshTable.next()
	}

	public handleModalNewCateg() {
		this.modalNewCateg = true
		this.category = new Category()
		this.categorySelected = new Category()
		this.imageUser = undefined
		this.existImage = false
	}

	public handleModalNewCategExit() {
		this.modalNewCateg = false
	}

	public handleModalEditCateg(categorySelected: Category, index: number) {
		this.modalEditCateg = true
		this.categorySelected = categorySelected
		if (categorySelected) {
			this.category = { ...categorySelected }
		}

		this.focusInput(`category${index}`)
	}

	public handleModalEditSubCateg(
		subCategorySelected: SubCategory,
		index: number
	) {
		this.modalEditSubCateg = true
		this.subCategorySelected = subCategorySelected
		if (subCategorySelected) {
			this.subCategory = { ...subCategorySelected }
		}

		this.focusInput(`subcategory${index}`)
	}

	public handleModalCategDataTable(classSelected: BotanicClassification) {
		this.modalDataTable = true
		if (classSelected) {
			this.categories.forEach(cat => {
				if (cat._id === classSelected.category_id) {
					this.categorySelected = { ...cat }
				}
			})
		}
	}

	public handleModalEditCategDataTable() {
		this.modalEditDataTable = true
	}

	public handleModalEditCategDataTableExit() {
		this.modalEditDataTable = false
	}

	public closeModalEditCategDataTable() {
		// this.categorySelected.media_url
		this.modalDataTable = false
		this.modalEditDataTable = false
	}

	public handleModalNewSubCateg() {
		this.modalNewSubCateg = true
		this.subCategory = new SubCategory()
	}

	public focusInput(id: string | number) {
		// const input = document.getElementById(`${id}`)
		// input.focus()

		setTimeout(() => {
			$(`#${id}`).focus()
		}, 100)
	}

	public handleModalNewSubCategExit() {
		this.modalNewSubCateg = false
	}

	public async handleModalEditClass(classSelected: BotanicClassification) {
		this.classSelected = classSelected
		if (classSelected) {
			this.categories.forEach(cat => {
				if (cat._id === classSelected.category_id) {
					this.categorySelected = cat
				}
			})
			await this.getSubCategoriesEdit(classSelected, false)
			this.modalEditClass = true
		}
	}

	public handleModalRemoveClass(classSelected: BotanicClassification) {
		this.classSelected = classSelected
		this.openDelete = true
	}

	public handleModalRemoveClassClose() {
		this.openDelete = false
	}

	public closeModalEditClass() {
		this.modalEditClass = false
	}

	public handleModalClassBotanic() {
		this.modalClassBotanic = true
		this.modalEditCateg = false
		this.tab1 = false
		this.tab2 = false
		this.tab3 = false
		$('[data-target=1]').addClass('active')
		$('[data-target=2]').removeClass('active')
		$('[data-target=3]').removeClass('active')
		$('[data-click=1]').addClass('active')
		$('[data-click=2]').removeClass('active')
		$('[data-click=3]').removeClass('active')
	}

	public closeModalClassBotanic() {
		this.modalClassBotanic = false
	}

	public getBotanicResolver() {
		this.isLoading = true
		this.botanicService.getClass().subscribe(response => {
			this.class = response

			if (!this.class) {
				this.notificationService.notify('Erro ao obter Classificações', 400)
			}

			this.isLoading = false
			return
		})

	}

	public getBotanic() {
		this.subscriptionGet = this.botanicService.getClass().subscribe(
			data => {
				this.class = data
				this.rerender()
			},
			error => {
				console.error(error)
			}
		)
		return
	}

	public refreshNewClass() {
		this.form.reset()
		document.querySelector('main').className = ''
		this.modalClassBotanic = false
		this.modalEditClass = false
		this.getBotanic()
		this.getCategories()
		this.category = new Category()
		this.subCategory = new SubCategory()
		this.alternative = new Alternative()
		this.alternativeSelected = new Alternative()
	}

	private initTab(): void {
		const clean = () => {
			this.form.form.markAsUntouched()
			this.form.form.markAsPristine()
			this.alternative.name = ''
		}
		$('[data-group]').each(function() {
			const $allTarget = $(this).find('[data-target]'),
				$allClick = $(this).find('[data-click]'),
				activeClass = 'active'

			$allClick.first().addClass(activeClass)
			$allTarget.first().addClass(activeClass)

			$allClick.click(function(e) {
				e.preventDefault()
				clean()
				const id = $(this).data('click'),
					$target = $('[data-target="' + id + '"]')
				$allClick.removeClass(activeClass)
				$allTarget.removeClass(activeClass)
				$target.addClass(activeClass)
				$(this).addClass(activeClass)
			})
		})
	}

	private setupDatatables() {
		this.datatableOptions = {
			language: {
				url:
					'//cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	public handleSendAndReplace($event, indice?: number): void {
		this.readThis($event.target, indice, false)
	}

	public handleSendAndReplaceAlternative($event): void {
		this.readThis($event.target, null, true)
	}

	public handleSendAndReplaceDataTable($event): void {
		this.readThis($event.target, null, true, this.categorySelected)
		$event.target.value = ''
	}

	public readThis(
		inputValue: any,
		indice?: number,
		mediaAlternative?: boolean,
		categorySelected?: Category
	): void {
		const file: File = inputValue.files[0]
		this.fileInput = file
		const myReader: FileReader = new FileReader()
		myReader.onloadend = e => {
			if (indice !== null) {
				this.categories[indice].media_url = myReader.result
			}
			if (categorySelected !== null) {
				this.categorySelected.media_url = myReader.result
			}
			if (mediaAlternative) {
				this.imageAlternative = myReader.result
				this.existImage = true
				this.onFileSelected(inputValue.files[0])
			}
			this.imageUser = myReader.result
			this.existImage = true
		}
		myReader.readAsDataURL(file)
	}

	public onFileSelected(fileInput: any) {
		const file = fileInput
		if (file) {
			this.notificationService.initLoading()
			this.awsService
				.uploadToS3(file)
				.then(data => {
					this.alternative.media_url = data.Location
					this.alternativeSelected.media_url = data.Location
					this.nameFileAlternative = data.key
					this.notificationService.stopLoading()
				})
				.catch(function(err) {
					console.log(err)
				})
		}
	}

	public getCategories() {
		this.subscriptionGet = this.botanicService.getCategories().subscribe(
			data => {
				this.categories = data
			},
			error => {
				console.log(error)
			}
		)
		return
	}

	public getSubCategories() {
		this.subscriptionGet = this.botanicService
			.getSubCategories(this.categorySelected._id)
			.subscribe(
				data => {
					this.subCategories = data
				},
				error => {
					console.log(error)
				}
			)
		return
	}

	public onChangeCategory(event: Category) {
		this.subCategorySelected = new SubCategory()
		this.alternativeSelected = new Alternative()
		this.getSubCategoriesEdit(this.classSelected, true)
	}

	public async getSubCategoriesEdit(
		classSelected: BotanicClassification,
		editCategorySelect: boolean
	): Promise<void> {
		const data: any = await this.botanicService
			.getSubCategories(this.categorySelected._id)
			.toPromise()

		data.forEach(sub => {
			if (sub.subCategory_id === classSelected.subCategory_id) {
				this.subCategorySelected = sub
			}
		})
		this.subCategories = data
		if (!editCategorySelect) {
			this.alternativeSelected = new Alternative()
			this.alternativeSelected._id = classSelected._id
			this.alternativeSelected.name = classSelected.alternative_name
			this.alternativeSelected.media_url = classSelected.alternative_midia
			this.imageAlternative = classSelected.alternative_midia
			if (this.alternativeSelected.media_url) {
				const split = this.alternativeSelected.media_url.split('.com/')
				this.nameFileAlternative = split[1]
			}
		}
	}

	public async saveCategory(indice?: number) {
		const file = this.fileInput
		let categorySave = new Category()
		if (file != undefined) {
			try {
				this.notificationService.initLoading()
				const data = await this.awsService.uploadToS3(file)
				categorySave.media_url = data.Location
				this.notificationService.stopLoading()
			} catch (error) {
				console.log(error)
			}
		}
		let enabledEdition = true
		let editionDataTable = false
		if (indice != undefined) {
			categorySave._id = this.categories[indice]._id
			categorySave.name = this.categories[indice].name
			categorySave.media_url = categorySave.media_url
			if (
				categorySave.name == this.category.name &&
				categorySave.media_url == null
			) {
				enabledEdition = false
			}
		} else if (this.categorySelected._id) {
			categorySave.name = this.categorySelected.name
			categorySave._id = this.categorySelected._id
			editionDataTable = true
		}
		if (enabledEdition) {
			if (!categorySave) {
				categorySave = this.category
			} else if (!categorySave._id) {
				categorySave.name = this.category.name
			}
			this.subscriptionAdd = this.botanicService
				.addCategory(categorySave)
				.subscribe(
					data => {
						if (editionDataTable) {
							this.closeModalEditCategDataTable()
							this.getCategories()
							this.getBotanic()
						} else {
							this.handleModalClassBotanic()
							this.refreshCategories()
						}
						this.notificationService.notify(data.message, 200)
					},
					error => {
						console.error(error)
					}
				)

			return
		} else {
			this.modalEditCateg = false
		}
	}

	public saveSubCategory(indice?: number) {
		let subCategorySave: SubCategory
		let enabledEdition = true
		if (indice !== undefined) {
			subCategorySave = this.subCategories[indice]
			if (subCategorySave.name === this.subCategory.name) {
				enabledEdition = false
			}
		}
		if (enabledEdition) {
			if (!subCategorySave) {
				subCategorySave = this.subCategory
			}
			subCategorySave._id = this.categorySelected._id
			this.subscriptionAdd = this.botanicService
				.addSubCategory(subCategorySave)
				.subscribe(
					data => {
						this.refreshSubCategories()
						this.modalEditSubCateg = false
						this.notificationService.notify(data.message, 200)
					},
					error => {
						console.error(error)
					}
				)
		}

		this.modalEditSubCateg = false
		return
	}

	public saveAlternative() {
		this.alternative.category_id = this.categorySelected._id
		this.alternative.subCategory_id = this.subCategorySelected.subCategory_id
		if (this.alternativeSelected._id) {
			this.alternative._id = this.alternativeSelected._id
			this.alternative.name = this.alternativeSelected.name
			this.alternative.media_url = this.alternativeSelected.media_url
		}
		this.subscriptionAdd = this.botanicService
			.addAlternative(this.alternative)
			.subscribe(
				data => {
					this.refreshNewClass()
					this.notificationService.notify(data.message, 200)
				},
				error => {
					console.error(error)
				}
			)
		return
	}

	public removeClass() {
		this.subscriptionRemove = this.botanicService
			.removeClass(this.classSelected._id)
			.subscribe(
				data => {
					this.refreshNewClass()
					this.handleModalRemoveClassClose()
					this.notificationService.notify(data.message, 200)
				},
				error => {
					console.log(error)
				}
			)
		return
	}

	public removeSub(sub: SubCategory) {
		this.subscriptionRemove = this.botanicService
			.removeSub(sub.subCategory_id)
			.subscribe(
				data => {
					this.getSubCategories()
					this.modalEditSubCateg = false
					this.notificationService.notify(data.message, 200)
				},
				error => {
					console.log(error)
				}
			)
		return
	}

	public removeCat(cat: Category) {
		this.subscriptionRemove = this.botanicService
			.removeCat(cat._id)
			.subscribe(
				data => {
					this.getCategories()
					this.handleModalClassBotanic()
					this.notificationService.notify(data.message, 200)
				},
				error => {
					console.log(error)
				}
			)
		return
	}

	public deleteImageAlternative() {
		this.alternativeSelected.media_url = undefined
	}

	public enterCategory(categorySelected: Category) {
		this.tab1 = true
		this.tab2 = true
		$('[data-target=2]').addClass('active')
		$('[data-target=1]').removeClass('active')
		$('[data-click=2]').addClass('active')
		$('[data-click=1]').removeClass('active')
		this.categorySelected = categorySelected
		this.subCategories = undefined
		this.getSubCategories()
		this.modalEditCateg = false
	}

	public enterSubCategory(subCategorySelected: SubCategory) {
		this.tab1 = true
		this.tab2 = true
		this.tab3 = true
		$('[data-target=1]').removeClass('active')
		$('[data-target=2]').removeClass('active')
		$('[data-target=3]').addClass('active')
		$('[data-click=1]').removeClass('active')
		$('[data-click=2]').removeClass('active')
		$('[data-click=3]').addClass('active')
		this.alternative.name = ''
		this.form.form.markAsUntouched()
		this.form.form.markAsPristine()
		this.subCategorySelected = subCategorySelected
		this.modalEditSubCateg = false
		this.imageAlternative = undefined
	}

	public refreshCategories() {
		this.getCategories()
		this.getBotanic()
		this.modalNewCateg = false
		this.fileInput = undefined
	}

	public refreshSubCategories() {
		this.modalNewSubCateg = false
		this.modalEditSubCateg = false
		this.getSubCategories()
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public ngOnDestroy() {
		if (this.subscriptionAdd) this.subscriptionAdd.unsubscribe()
		if (this.subscriptionGet) this.subscriptionGet.unsubscribe()
		if (this.subscriptionRemove) this.subscriptionRemove.unsubscribe()
	}
}
